export const popups = {
  registerRequest: {
    title: 'Запит на реєстрацію',
    description: 'Заповніть форму, і ми зв’яжемося з вами.',
    button: 'Надіслати запит на реєстрацію',
    form: {
      noteLabel: 'Звідки ви про нас дізналися?',
      notePlaceholder: 'Звідки ви про нас дізналися?',
      checkboxExperience: 'Маю досвід у клубі',
      club: {
        nameLabel: 'Назва клубу',
        namePlaceholder: 'Назва клубу'
      }
    }
  },
  invite: {
    title: 'Підтвердьте вік',
    description:
      'Вам є 18 років? Підтвердіть свій вік, щоб користуватися платформою.',
    confirm: 'Так, мені 18'
  },
  deleteAccount: {
    title: 'Видалити акаунт?',
    subTitle: 'Скасувати видалення буде неможливо.',
    description:
      'Замість видалення можна приховати профіль. Він буде видимий лише вам, доки ви не вирішите знову відкрити його.'
  },
  exitFromProfile: {
    title: 'Вийти?',
    description: 'Підтвердіть вихід з акаунта.'
  },
  hideAccount: {
    title: 'Приховати профіль?',
    description:
      'Ваш профіль не буде видимим для нікого, крім вас, доки ви не вирішите його знову відкрити.'
  },
  mainPhoto: {
    title: 'Фото обкладинки',
    description: 'Оберіть фото обкладинки для вашого резюме'
  },
  updateVideo: {
    title: 'Завантаження відео',
    description: 'Зачекайте, поки відео завантажиться'
  },
  consumation: {
    title: 'Консумація',
    description:
      'Вкажіть п’ять найпопулярніших позицій консумації, їхню вартість і відсоток виплат артисту.'
  },
  crazyMenu: {
    title: 'Шалене меню',
    description:
      'Вкажіть п’ять найпопулярніших позицій шаленого меню та їхню вартість.'
  },
  warningOnCloseOnboarding: {
    title: 'Ви впевнені?',
    description:
      'Ви впевнені, що хочете зупинити заповнення даних? Ваше резюме не буде опубліковано. Клуби не зможуть надіслати вам свої найкращі пропозиції. Ви зможете продовжити пізніше.'
  },
  foreignLanguage: {
    title: 'Рівень володіння'
  },
  createWorkItem: {
    title: 'Підтвердити запрошення',
    titleRequest: 'Підтвердити запит',
    inviteDescription:
      'Ці дані попередні. Ви можете обговорити їх у чаті з артистом і оновити запрошення.',
    requestDescription:
      'Ці дані попередні. Ви можете обговорити їх у чаті з клубом і оновити запит.',
    suggestVacancy: 'Запропонувати артисту вакансію',
    selectVacancy: 'Вкажіть цікаву вакансію',
    ticketCreditOption: 'Опція авансу на квиток',
    ticketCreditRequired: 'Потрібен аванс на квиток?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: 'Артист працює у вашому клубі.',
    setLastDay: {
      title: 'Встановити останній робочий день?',
      setLastWorkDate: 'Оберіть останній робочий день артиста',
      description:
        'Після встановлення останньої дати змінити її неможливо. Після цієї дати артист завершить контракт у вашому клубі.'
    },
    artistArrival: {
      title: 'Підтвердити прибуття артиста?',
      description: 'Ви підтверджуєте присутність артиста у вашому клубі.',
      information:
        'Робота розпочнеться після підтвердження присутності артиста на робочому місці.'
    },
    workCancel: {
      title: 'Скасувати договір?',
      description: 'Ви підтверджуєте скасування договору.'
    },
    wantEndDate: {
      title: 'Артист хоче встановити останній день.'
    },
    newEndDate: {
      title: 'Останній робочий день'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        'Ваш запит на завершення контракту розглядається.',
      workStartOnArtistArrivalConfirm:
        'Робота розпочнеться після того, як клуб підтвердить вашу присутність на робочому місці.',
      weCanRequestLastWorkDate:
        'Запитайте дату завершення контракту в клубу.',
      clubSetLastWorkDate:
        'Клуб встановив дату вашого останнього робочого дня в цьому клубі.'
    }
  },
  changeProfile: {
    title: 'Мої клуби'
  },
  confirmOnboardingCompletion: {
    title: 'Ваше портфоліо опубліковано',
    description: 'Тепер клуби зможуть запрошувати вас до роботи.'
  },
  videoUploading: {
    title: 'Завантаження відео',
    description: 'Зачекайте, поки відео завантажиться'
  },
  addWorkItem: {
    title: 'Місце роботи',
    vacancyQuestion: 'На якій вакансії ви працювали?',
    validationMessage: 'Ви вже зазначили, що зараз працюєте.'
  },
  selectMainPhoto: {
    title: 'Головне фото',
    description: 'Оберіть фото обкладинки для вашого резюме'
  },
  deleteWorkExperience: {
    title: 'Видалити?',
    description: 'Ви впевнені, що хочете видалити цей досвід роботи?'
  }
};
